import * as React from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  inputValue: string
}

function NoAirportsOption({ inputValue }: Props) {
  const intl = useIntl()

  const notFoundMessage = intl.formatMessage(
    {
      id: '20QK9GM4bx0AjOtGo6UU',
      defaultMessage: 'Sorry, we couldn’t find <bold>‘{inputValue}’</bold>.',
      description: 'Message shown when no airports are found for the search input',
    },
    {
      inputValue,
      bold: (chunks: React.ReactNode) => (
        <BodyText key="bold" variant="medium" weight="bold" as="span">
          {chunks}
        </BodyText>
      ),
    },
  )

  const suggestionMessage = intl.formatMessage({
    id: 'ULRyhLqL7ZoRmwINz6qG',
    defaultMessage: 'Check your spelling, or try searching for a new airport.',
    description: 'Suggestion message when no airports are found in the flights section',
  })

  return (
    <div>
      <BodyText variant="medium" colour="neutral-two" wrap="truncate">
        {notFoundMessage}
      </BodyText>
      <BodyText variant="medium" colour="neutral-two">
        {suggestionMessage}
      </BodyText>
    </div>
  )
}

export default NoAirportsOption
